import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, GroupFilterParams, DetailFilterParams} from './types';
import {getNumber} from "@/utils/data-helper"

export const actions: ActionTree<StatisticState, RootState> = {
  async getSmsStatisticDetail({commit, dispatch}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/sms',
        params: data,
      })
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit('pushSmsStatisticDetail', messages);
      } else {
        commit('setSmsStatisticDetail', messages);
      }
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async exportSmsStatisticDetail({commit, dispatch}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/sms/export',
        params: data,
      });
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async getSmsStatisticDetailInfo({ commit, dispatch }, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/sms/" + id.replace(/#/g, "%23"),
      });
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async getSmsStatisticGroup({commit, dispatch}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/sms',
        params: data,
      })
      commit('setSmsStatisticGroup', resp.data);
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async exportSmsStatisticGroup({commit, dispatch}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/sms/export',
        params: data,
      })
      return resp;
    } catch(err) {
      throw err;
    }
  },
};
